var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8992 3.82227L3.82227 11.3778L10.5915 20.8223L19.8223 9.48893L14.8992 3.82227Z",
    stroke: "#38424A",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.8262,
    y: 0.822266,
    width: 4.5,
    height: 4.5,
    transform: "rotate(41.876 14.8262 0.822266)",
    fill: "#38424A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.82617,
    y: 7.82227,
    width: 4.5,
    height: 4.5,
    transform: "rotate(41.876 3.82617 7.82227)",
    fill: "#38424A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8262,
    y: 6.82227,
    width: 4.5,
    height: 4.5,
    transform: "rotate(41.876 19.8262 6.82227)",
    fill: "#38424A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8262,
    y: 16.8223,
    width: 4.5,
    height: 4.5,
    transform: "rotate(41.876 10.8262 16.8223)",
    fill: "#38424A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.14159250fa8a42ef2c0c4cf6b6d657e9.svg";
export { ForwardRef as ReactComponent };